import posthog from 'posthog-js';
import { getOrCreateTrackingId } from './trackingManager';
import { getStoredUtmParams } from './utmManager';
import { getStoredReferrer } from './referralManager';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || 'phc_bjgFKwlx2JKbHy2ckYGudXS360rkJrRN68G40ie2dh';
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let initialized = false;
let aguardando = false;

// Medição é categoria de consentimento, e o PostHog grava cookie e sessão.
// Enquanto a pessoa não escolhe, nada é carregado: um aviso de cookies que não
// segura o que ele promete segurar é só enfeite.
const temConsentimento = () =>
  typeof window !== 'undefined' && Boolean(window.bcConsentimento && window.bcConsentimento.medicao);

export const initPostHog = () => {
  if (initialized || !POSTHOG_KEY) return;
  if (!temConsentimento()) {
    // Quem aceita depois do carregamento também passa a ser medido.
    if (typeof window !== 'undefined' && !aguardando) {
      aguardando = true;
      window.addEventListener('bc:consentimento', () => initPostHog());
    }
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    persistence: 'localStorage+cookie',
    loaded: (ph) => {
      const trackingId = getOrCreateTrackingId();
      ph.register({
        tracking_id: trackingId,
        landing_page: window.location.href,
        ...getUtmSuperProperties(),
      });
    },
  });

  initialized = true;
};

const getUtmSuperProperties = () => {
  const utms = getStoredUtmParams();
  const referrer = getStoredReferrer();
  return {
    ...(utms || {}),
    ...(referrer ? { referrer } : {}),
  };
};

const getBaseProperties = () => ({
  tracking_id: getOrCreateTrackingId(),
  ...getUtmSuperProperties(),
  landing_page: window.location.href,
});

export const trackEvent = (eventName, properties = {}) => {
  if (!POSTHOG_KEY || !initialized) return;
  posthog.capture(eventName, {
    ...getBaseProperties(),
    ...properties,
  });
};

export const identifyUser = (distinctId, userProperties = {}) => {
  if (!POSTHOG_KEY || !initialized) return;
  const trackingId = getOrCreateTrackingId();
  posthog.identify(distinctId, {
    tracking_id: trackingId,
    ...userProperties,
  });
};

export const aliasUser = (alias) => {
  if (!POSTHOG_KEY || !initialized) return;
  posthog.alias(alias);
};

export { posthog };
